import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import { HashRouter } from 'react-router';

import { config } from './config';
import { main } from './configuration';
import { handleLoginRedirect } from './configuration/login/redirect';
import { store } from './configuration/setup/store';
import App from './features/app/App';
import { ErrorBoundary } from './features/app/ErrorBoundary';

const renderApplication = () => {
    const container = document.getElementById('root');
    const root = createRoot(container!);

    root.render(
        <ErrorBoundary>
            <Provider store={store}>
                <HashRouter>
                    <App />
                </HashRouter>
            </Provider>
        </ErrorBoundary>,
    );
};

const isDev = import.meta.env.DEV;
const isProd = import.meta.env.PROD;
const isProdPreview = import.meta.env.VITE_PRODUCTION_PREVIEW;
const useMockServer = (isDev && config.enableMockServer) || isProdPreview;

if (window.location.href.startsWith(config.login.redirectUri as string) && !useMockServer) {
    handleLoginRedirect();
} else if (useMockServer) {
    import('@mocks/browser').then(({ startWorker }) => startWorker()).then(() => main(renderApplication));
} else if (isDev || isProd) {
    main(renderApplication);
}
